export default "__VITE_ASSET__WA9CTH_5__"